export enum EnvironmentName {
  Auto = 'AUTO_QA',
  Dev = 'DEV',
  Demo = 'DEMO',
  Local = 'LOCAL',
  Mock = 'MOCK',
  Prod = 'PROD',
  Stage = 'STAGE',
  Qa = 'QA',
}

export enum ApplicationTypeToken {
  IntrackApp = 'INTRACK_APP',
  PublicTrackingApp = 'PUBLIC_TRACKING_APP',
}
